class StringUtils {
  static IP = process.env.SERVER || "";
  //TODO CHANGE
  // static IP = "http://localhost:4001";

  static DatabaseIP = "localhost";
}
export default StringUtils;
